module.exports = __webpack_public_path__ + "img/topup_orange.889cad61.svg";